import type { BaseModelAttributes } from "./base";

export enum DesktopReleaseStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
  DISABLED = "disabled",
}

export enum DesktopArtifactPlatform {
  WINDOWS = "windows",
  MACOS = "macos",
}

export enum DesktopArtifactArch {
  X64 = "x64",
  ARM64 = "arm64",
  UNIVERSAL = "universal",
}

export enum DesktopDistribution {
  INSTALLER = "installer",
  PORTABLE = "portable",
}

export enum DesktopArtifactFormat {
  EXE = "exe",
  DMG = "dmg",
  ZIP = "zip",
}

export interface DesktopReleaseResponse extends BaseModelAttributes {
  version: string;
  releaseNotes: string | null;
  status: DesktopReleaseStatus;
  publishedAt: Date | null;
  artifactCount: number;
}

export interface DesktopReleaseArtifactResponse extends BaseModelAttributes {
  releaseId: string;
  platform: DesktopArtifactPlatform;
  arch: DesktopArtifactArch;
  distribution: DesktopDistribution;
  format: DesktopArtifactFormat;
  url: string;
  fileName: string;
  fileSize: number;
  sha256: string;
  enabled: boolean;
}

export interface DesktopUpdateManifestResponse {
  version: string;
  releaseNotes: string | null;
  publishedAt: Date;
  artifact: {
    id: string;
    platform: DesktopArtifactPlatform;
    arch: DesktopArtifactArch;
    distribution: DesktopDistribution;
    format: DesktopArtifactFormat;
    url: string;
    fileName: string;
    fileSize: number;
    sha256: string;
  };
}

export interface CreateDesktopReleaseRequest {
  version: string;
  releaseNotes?: string;
  status?: DesktopReleaseStatus;
}

export interface UpdateDesktopReleaseRequest {
  releaseNotes?: string;
  status?: DesktopReleaseStatus;
}

export interface DesktopReleaseArtifactRequest {
  platform: DesktopArtifactPlatform;
  arch: DesktopArtifactArch;
  distribution: DesktopDistribution;
  format: DesktopArtifactFormat;
  url: string;
  fileName: string;
  fileSize: number;
  sha256: string;
  enabled?: boolean;
}
